
$('.js-btn-favorite').on('click', function(){
    $(this).toggleClass('checked');
})
